import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { CoverageReportAction } from './coverageReport.action';
import { coverageReportInitialState } from './coverageReport.constant';
import { ICoverageReportStore } from './coverageReport.interface';

export const coverageReportReducer = reducerWithInitialState(coverageReportInitialState)
  .case(CoverageReportAction.loadList.started, (state): ICoverageReportStore => ({
    ...state,
    listNetworkStatus: NetworkStatus.Started,
  }))
  .case(CoverageReportAction.loadList.done, (state, { result }): ICoverageReportStore => ({
    ...state,
    data: Object.fromEntries(result.map((report) => [report.reportId, report])),
    listNetworkStatus: NetworkStatus.Done,
  }))
  .case(CoverageReportAction.loadList.failed, (state): ICoverageReportStore => ({
    ...state,
    listNetworkStatus: NetworkStatus.Failed,
  }))
  .case(CoverageReportAction.remove.done, (state, { params }): ICoverageReportStore => {
    const data = { ...state.data };
    delete data[params.reportId];
    return { ...state, data };
  })
  .case(CoverageReportAction.destroy, () => ({ ...coverageReportInitialState }));
